import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { orderBy } from 'lodash-es';
import Search from 'sushiweb/Icons/all/Search';
import { searchWithName } from '../../../helpers';
import DataTables from '../../common/components/DataTables/DataTables';
import {
  currentFlowTypeEnum,
  REFRESH_LABEL,
} from '../../common/components/constants';
import ErrorPage from '../../common/components/ErrorPage/ErrorPage';
import {
  SearchContainerV2,
  SearchInput,
  TableContainer,
} from '../../common/styles';
import { giftingRecipientsHeadColumn } from '../../common/components/DataTables/components/headColumns';

const GiftingRecipientsTable = ({
  getAllEmployees,
  fetchingEmployees,
  selectedWorkspace,
  employeesData,
  fetchedEmployees,
}) => {
  const keyFields = ['email'];
  const { employees = [] } = employeesData;
  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, onInputChange] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [disabledSearch, setDisabledSearch] = useState(false);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id)
      getAllEmployees({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD,
      });
  }, [selectedWorkspace]);

  const gcFlowEmployeeFilter = val => {
    if (
      val?.benefit_details?.gift_card?.status !== 0 &&
      val?.benefit_details?.gift_card?.adhoc_program_id !== ''
    )
      return true;
    return false;
  };

  useEffect(() => {
    if (!fetchingEmployees) {
      if (employees) {
        employees.sort(
          (a, b) => new Date(b.created_on) - new Date(a.created_on),
        );
        if (employees.length === 0) {
          setDisabledSearch(true);
        }
        const filterFlowTypeData = employees.filter(gcFlowEmployeeFilter);
        setSearchResults(filterFlowTypeData);
        setCurrentData(filterFlowTypeData.slice(0, 10));
      }
      setLoading(false);
    }
  }, [fetchingEmployees]);

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const timeout = setTimeout(() => {
      if (!fetchingEmployees) {
        const arr = searchWithName(employees, search, keyFields);
        const filterFlowTypeData = arr.filter(gcFlowEmployeeFilter);
        setSearchResults(filterFlowTypeData);
        handlePageChange(1);
      }
    }, 500);

    return () => setTypingTimeout(timeout);
  }, [search, fetchingEmployees]);

  useEffect(() => {
    if (searchResults) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = searchResults.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage, searchResults]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const refreshPage = () => {
    getAllEmployees({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD,
    });
  };

  const handleSort = (column, sortDirection) => {
    setSearchResults(orderBy(searchResults, column.selector, sortDirection));
  };

  return (
    <>
      <SearchContainerV2>
        <SearchInput
          leftIcon={<Search />}
          innerWidth='100%'
          value={search}
          onChange={onInputChange}
          onFocus={() => setIsSearchClicked(true)}
          onBlur={() => setIsSearchClicked(false)}
          label={
            isSearchClicked || disabledSearch || search?.length ? (
              'Search by email ID'
            ) : (
              <span style={{ fontSize: '16px', fontWeight: 300 }}>
                {' '}
                Search by email ID
                {' '}
              </span>
            )
          }
          disabled={disabledSearch}
        />
      </SearchContainerV2>
      <TableContainer>
        {!fetchedEmployees ? (
          <ErrorPage
            showAction
            actionLabel={REFRESH_LABEL}
            clickAction={refreshPage}
          />
        ) : (
          <DataTables
            columns={giftingRecipientsHeadColumn}
            loading={fetchingEmployees || loading}
            data={currentData}
            pagination
            totalRows={searchResults.length}
            handlePageChange={handlePageChange}
            onSort={handleSort}
            emptyStateTitle='No recipients'
          />
        )}
      </TableContainer>
    </>
  );
};

GiftingRecipientsTable.propTypes = {
  employeesData: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  getAllEmployees: PropTypes.func,
  fetchingEmployees: PropTypes.bool,
  fetchedEmployees: PropTypes.bool,
};

GiftingRecipientsTable.defaultProps = {
  employeesData: {},
  selectedWorkspace: {},
  getAllEmployees: _noop,
  fetchingEmployees: true,
  fetchedEmployees: true,
};

export default GiftingRecipientsTable;
